<template>
  <Layout>
    <vue-confirm-dialog></vue-confirm-dialog>
    <router-view :key="$route.path" />
    <upload-file-popup></upload-file-popup>
    <confirm-popup></confirm-popup>
    <notification></notification>
  </Layout>
</template>
<script>
import Layout from "@/layouts/Layout";
import UploadFilePopup from "@/components/UploadFilePopup";
import ConfirmPopup from "@/components/ConfirmPopup";
import Notification from "@/components/Notification";

export default {
  components: { Layout, UploadFilePopup, ConfirmPopup, Notification },
  beforeMount() {
    this.$store.dispatch("initTheme");
  },
};
</script>
<style>
@import "assets/css/common.css";
</style>
